/**
 * @file
 * Mapbox code for "mijn omgeving" page.
 */

import 'polyfill-array-includes';

import {
  belgiumBounds,
  mapboxAccessToken,
  locationIqKey,
  createGeometry,
  createGeoJSONCircle,
} from '../../../../themes/custom/didtheme/src/utils/MapUtils';

(($, Drupal, mapboxgl, Fuse, Validator) => {
  Drupal.behaviors.mapsInit = {
    attach(context, settings) {
      if (!$('.dash_projectmap--map', context).length) {
        return;
      }

      var isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function () {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
      };

      let {json} = settings.maps;
      json = JSON.parse(json);

      let $listItems = $('.map-n-list .overview--list_items');
      // Init list.
      let $projectsTable = ``;
      json.features.forEach(project => {
        $projectsTable +=
          `<a href="${project.url}" class="project overview--list_item">
             <div data-filter="start_date" class="overview--list_header-date overview--list_item-column"><span class="filterlabel">${Drupal.t('Start date')}</span>${project.dates.project_start}</div>
             <div data-filter="end_date" class="overview--list_header-date overview--list_item-column"><span class="filterlabel">${Drupal.t('End date')}</span>${project.dates.project_end}</div>
             <div data-filter="project_name" class="overview--list_header-name overview--list_item-column">${project.properties.name}</div>
           </a>`;
      });
      $listItems.append($projectsTable);

      let toggleMode = 'loc';
      let locationClick = false;
      let selectedPoint;
      let selectedProject;
      let subscribed = false;
      const infoText = $('.dash_projectmap--stayinformed-info p').text();
      let formClosed = false;
      let isMobileDevice = false;

      if (isMobile.any()) {
        isMobileDevice = true;
      }

      mapboxgl.accessToken = mapboxAccessToken;
      const map = new mapboxgl.Map({
        container: 'map',
        style:
          'mapbox://styles/didmapboxfrederik/ciz02ulow00032rnsyzqba92c?optimize=true',
        center: [4.1072426, 51.0925963],
        zoom: 8,
        maxBounds: belgiumBounds,
        dragpan: false,
        attributionControl: true,
      });

      // Dimensions on split
      let $mapContainer = $('.dash_projectmap--map', context);
      let mapCanvas = document.getElementsByClassName('mapboxgl-canvas')[0];

      if ($(window).innerWidth() >= 1200) {
        $('.map-toggle-container').on('click', () => {
          if ($mapContainer.hasClass('split')) {
            $mapContainer.css('width', '100%');
            mapCanvas.style.width = '100%';
            map.resize();
          } else {
            $mapContainer.css('width', '49%');
            mapCanvas.style.width = '100%';
            map.resize();
          }
        });
      }

      const hideProjectBox = () => {
        $('.dash_projectmap--infoblock').fadeOut(50);
      };

      const showProjectBox = () => {
        const $map = $('#map');
        if ($(window).innerWidth() < 768) {
          $('.dash_projectmap--infoblock').css({
            left: `${$map.position().left + $map.width() / 2 - 140}px`,
            top: `${$map.position().top + $map.height() / 2}px`,
          });
        } else if ($(window).innerWidth() < 1200) {
          $('.dash_projectmap--infoblock').css({
            left: `${$map.position().left + $map.width() / 2 - 140}px`,
            top: `${$map.position().top + $map.height() / 2 + 175}px`,
          });
        } else {
          $('.dash_projectmap--infoblock').css({
            left: `${$map.position().left + $map.width() / 2 + 70}px`,
            top: `${$map.position().top + $map.height() / 2}px`,
          });
        }
        $('.dash_projectmap--infoblock').fadeIn(250);
      };

      const setWarningStep1 = () => {
        $('.search-projectnr').addClass('active');
        $('.map-guide-step1').addClass('active');
        $('.mapboxgl-ctrl-geocoder').addClass('active');
        if ($('.mapboxgl-ctrl-geocoder')[0].style.display === 'none') {
          $('.search-projectnr')[0]
            .querySelector('input')
            .focus();
        } else {
          $('.mapboxgl-ctrl-geocoder')[0]
            .querySelector('input')
            .focus();
        }
      };

      const disableWarningStep1 = () => {
        $('.search-projectnr').removeClass('active');
        $('.map-guide-step1').removeClass('active');
        $('.mapboxgl-ctrl-geocoder').removeClass('active');
        $('.dash_projectmap--stayinformed-form').addClass('active');
        $('.location-info').addClass('active');
      };

      const showMapData = (data, nodeId) => {
        const jsonString = data.json;
        const geometry = createGeometry(jsonString);

        if (map.getSource('route')) {
          map.removeSource('route');
        }

        map.addSource('route', {
          type: 'geojson',
          data: {
            type: 'Feature',
            properties: {},
            geometry,
          },
        });

        if (map.getLayer('route')) {
          map.removeLayer('route');
        }

        map.addLayer({
          id: 'route',
          type: 'fill',
          source: 'route',
          paint: {
            'fill-color': '#FF6E00',
            'fill-opacity': 0.5,
            'fill-outline-color': '#FF6E00',
          },
        });

        $('.dash_projectmap--infoblock-projectinfo .startdate').html(
          data.start_date,
        );
        $('.dash_projectmap--infoblock-projectinfo .enddate').html(
          data.end_date,
        );
        $('.dash_projectmap--infoblock-button a').attr('href', data.url);

        const found = json.features.find(
          element => element.properties.node === nodeId,
        );

        if (found.cta) {
          $('.dash_projectmap--infoblock-link a').data('cta', found.cta);
          $('.dash_projectmap--infoblock-link').show();
        } else {
          $('.dash_projectmap--infoblock-link').hide();
        }
      };

      const loadJSONData = nodeId => {
        $.ajax({
          url: `/project/${nodeId}/details`,
          context: document.body,
          dataType: 'json',
        }).then(data => {
          showMapData(data, nodeId);
        });
      };

      const setRadius = () => {
        if (subscribed) {
          $('.dash_projectmap--stayinformed-info p').text(infoText);
          $('.dash_projectmap--stayinformed-form').slideDown();

          $('.dash_projectmap--stayinformed-form input[name="firstname"]').val(
            '',
          );
          $('.dash_projectmap--stayinformed-form input[name="lastname"]').val(
            '',
          );
          $('.dash_projectmap--stayinformed-form input[name="email"]').val('');

          subscribed = false;
        }

        const radius = $('.dash_projectmap--stayinformed-form #radius').val();

        if (selectedPoint) {
          map
            .getSource('polygon')
            .setData(
              createGeoJSONCircle(
                selectedPoint.geometry.coordinates,
                radius / 1000,
              ).data,
            );
          map.getSource('single-point').setData(selectedPoint.geometry);
        }
      };

      let searchingProject = false;
      let searchingGeocoder = false;

      const fuseOptions = {
        shouldSort: true,
        threshold: 0.1,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['properties.reference'],
      };

      const clearInfoblock = () => {
        $('.dash_projectmap--infoblock-projectinfo p').html('');
        $('.dash_projectmap--infoblock-link a').data('cta', '');
        $('.dash_projectmap--infoblock-link').hide();
      };

      const selectProject = (marker, bypass) => {
        selectedProject = marker.properties.reference;
        locationClick = false;
        const btn = $('.form-teaser');
        btn.hide();

        clearInfoblock();

        $('.dash_projectmap--infoblock-projectinfo p').html(
          marker.properties.name,
        );

        $('.dash_projectmap--stayinformed').fadeOut(250);

        loadJSONData(marker.properties.node);

        if (isMobileDevice) {
          map.jumpTo({
            center: [
              marker.geometry.coordinates[0],
              marker.geometry.coordinates[1],
            ],
            zoom: 15,
          });

        } else {
          map.flyTo({
            center: [
              marker.geometry.coordinates[0],
              marker.geometry.coordinates[1],
            ],
            zoom: 15,
          });
        }

        map.once('moveend', () => {
          if ($(window).innerWidth() < 768 && bypass === undefined) {
            const btn = $('.form-teaser');
            btn.show();
            btn.find($('.location-teaser')).hide();
            btn.find($('.project-teaser')).show();
            btn.off('click');
            btn.on('click', () => {
              if (toggleMode === 'proj' && !locationClick) {
                btn.hide();
                showProjectBox(selectedProject);
              }
            })
          } else {
            showProjectBox(selectedProject);
          }
        });
      };

      const fuse = new Fuse(json.features, fuseOptions);

      const chooseProject = projectnr => {
        const result = fuse.search(projectnr.toString());

        if (result.length) {
          selectProject(result[0]);
          $('.search-projectnr input[type="text"]').val(projectnr.toString());
          $('.search-projectnr .suggestions').hide();
          $('.search-projectnr input[type="text"]').blur();
        }
      };

      const openForm = () => {
        formClosed = false;
        if (selectedPoint) {
          disableWarningStep1();
        }
        $('.dash_projectmap--stayinformed').fadeIn(250);
        if ($(window).innerWidth() < 768) {
          $('html, body').animate({
              scrollTop: $('.dash_projectmap--stayinformed').offset().top - 250,
            },
            300,
          );
        }
        locationClick = false;
      };

      const resetGeocoder = () => {
        searchingGeocoder = false;
        $('.search-geocoder .suggestions').hide();
        $('.search-geocoder input[type="text"]').val('');
        $(document).off('.searchGeocoder');
      };

      const resetProjectSearch = () => {
        searchingProject = false;
        $('.search-projectnr .suggestions').hide();
        $('.search-projectnr input[type="text"]').val('');
        $(document).off('.searchProject');
      };

      const chooseLocation = (bounding, lon, lat) => {
        selectedPoint = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [lon, lat],
          },
        };

        setRadius();

        // Update project list.
        let radius = parseInt($('.dash_projectmap--stayinformed-form #radius').val());
        let selectedLon = selectedPoint.geometry.coordinates[0];
        let selectedLat = selectedPoint.geometry.coordinates[1];
        updateProjectsList(json, radius, selectedLat, selectedLon);

        const arr = bounding.split(',');
        const localBounds = new mapboxgl.LngLatBounds();
        localBounds.extend(new mapboxgl.LngLat(arr[2], arr[0]));
        localBounds.extend(new mapboxgl.LngLat(arr[3], arr[1]));

        if (isMobileDevice) {
          map.jumpTo({
            center: [
              selectedPoint.geometry.coordinates[0],
              selectedPoint.geometry.coordinates[1],
            ],
            zoom: 15,
          });
        } else {
          map.flyTo({
            center: [
              selectedPoint.geometry.coordinates[0],
              selectedPoint.geometry.coordinates[1],
            ],
            essential: true,
          });
        }

        map.once('moveend', () => {
          if ($(window).innerWidth() < 768) {
            const btn = $('.form-teaser');
            btn.show();
            btn.find($('.location-teaser')).show();
            btn.off('click');
            btn.on('click', () => {
              if (toggleMode === 'loc') {
                btn.hide();
                openForm();
              }
            })
          } else {
            openForm();
          }

        });

        resetGeocoder();
      };

      /**
       * Filters out duplicate results.
       * @param {Object[]} results - The results array from LocationIQ.
       * @return {Object[]} - The filtered results.
       */
      const filterDuplicateResults = results => {
        const uniqueDisplayNames = [];

        return results.filter(element => {
          if (uniqueDisplayNames.includes(element.display_name)) {
            return false;
          }
          uniqueDisplayNames.push(element.display_name);

          return true;
        });
      };

      /**
       * Filters out unwanted results.
       * @param {Object[]} results - The results array from LocationIQ.
       * @return {Object[]} - The filtered results.
       */
      const filterUnwantedResults = results => {
        return results.filter(element => {
          // We don't want highways in our results.
          if (
            element.class === 'highway' &&
            element.type === 'motorway_junction'
          ) {
            return false;
          }

          return true;
        });
      };

      let typingTimer;
      const searchGeo = text => {
        const typeInterval = 1000;
        const maxItems = 5;
        clearTimeout(typingTimer);

        typingTimer = setTimeout(() => {
          // We do not use the autocomplete API since it does not support
          // Dutch results.
          // This doesn't always give us good results
          // eg. Gent doesn't gives Gentbrugge as result.
          fetch(
            `https://eu1.locationiq.com/v1/search.php?key=${locationIqKey}&q=${text}&format=json&accept-language=nl&countrycodes=be&addressdetails=1&limit=10`,
          )
            .then(res => {
              if (res.status === 200) {
                return res.json();
              }
            })
            .then(data => {
              $('.search-geocoder .suggestions li').remove();

              if (data) {
                $('.search-geocoder .suggestions').show();

                // We show a maximum of 5 items without duplicates and unwanted.
                data = filterUnwantedResults(data);
                data = filterDuplicateResults(data);
                data = data.slice(0, maxItems);

                for (let i = 0; i < data.length; i++) {
                  $('.search-geocoder .suggestions').append(
                    `<li data-bounding="${data[i].boundingbox}" data-lon="${
                      data[i].lon
                    }" data-lat="${data[i].lat}"><a>${
                      data[i].display_name
                    }</a></li>`,
                  );
                }

                $('.search-geocoder .suggestions li a').on('click', e => {
                  chooseLocation(
                    $(e.currentTarget)
                      .closest('li')
                      .data('bounding'),
                    $(e.currentTarget)
                      .closest('li')
                      .data('lon'),
                    $(e.currentTarget)
                      .closest('li')
                      .data('lat'),
                  );
                });
              } else {
                $('.search-geocoder .suggestions').hide();
              }
            })
            .catch(e => {
              console.error(e);
            });
        }, typeInterval);
      };

      const searchProject = projectnr => {
        const result = fuse.search(projectnr);

        const max = result.length > 5 ? 5 : result.length;

        if (result.length === 0) {
          $('.search-projectnr .suggestions').hide();
        } else {
          $('.search-projectnr .suggestions').show();
        }

        $('.search-projectnr .suggestions li').remove();

        for (let i = 0; i < max; i++) {
          $('.search-projectnr .suggestions').append(
            `<li data-project="${result[i].properties.reference}"><a>${
              result[i].properties.name
            }</a></li>`,
          );
        }

        $('.search-projectnr .suggestions li a').on('click', e => {
          chooseProject(
            $(e.currentTarget)
              .closest('li')
              .data('project'),
          );
        });
      };

      const createMarkers = () => {
        const markers = {
          type: 'geojson',
          data: json,
          cluster: true,
          clusterRadius: 50,
          clusterMaxZoom: 10,
        };
        map.addSource('markers', markers);

        map.addLayer({
          id: 'markers',
          source: 'markers',
          type: 'circle',
          paint: {
            'circle-radius': {
              property: 'point_count',
              stops: [
                [0, 16],
                [1, 16],
                [2, 20],
                [5, 24],
                [10, 28],
                [20, 32],
                [50, 36],
                [100, 40],
                [200, 44],
                [99999, 16], // "default" doesn't work in this api version -> use high number to set a default
              ],
            },
            'circle-color': {
              property: 'point_count',
              stops: [
                [0, '#B9D216'],
                [1, '#B9D216'],
                [2, '#ffffff'],
                [99999, '#B9D216'], // "default" doesn't work in this api version -> use high number to set a default
              ],
            },
            'circle-stroke-width': {
              property: 'point_count',
              stops: [
                [0, 8],
                [1, 8],
                [2, 4],
                [99999, 8], // "default" doesn't work in this api version -> use high number to set a default
              ],
            },
            'circle-stroke-color': {
              property: 'point_count',
              stops: [
                [0, '#ffffff'],
                [1, '#ffffff'],
                [2, '#B9D216'],
                [99999, '#ffffff'], // "default" doesn't work in this api version -> use high number to set a default
              ],
            },
            'circle-stroke-opacity': 0.85,
          },
        });

        map.addLayer({
          id: 'cluster-count',
          source: 'markers',
          type: 'symbol',
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-size': 12,
          },
        });

        $('.dash_projectmap--infoblock-link a').click(clickEvent => {
          const $element = $(clickEvent.currentTarget);
          clickEvent.preventDefault();
          Drupal.ajax({url: $element.data('cta')}).execute();
        });
      };

      $('.search-toggle a', context).click(e => {
        e.preventDefault();
        const element = e.currentTarget;
        const btn = $('.form-teaser');
        btn.find($('span')).hide();
        btn.hide();
        $('.search-toggle a').removeClass('selected');
        $(element).addClass('selected');

        if ($(element).hasClass('toggle-location')) {
          toggleMode = 'loc';
          $('.search-geocoder').show();
          $('.search-projectnr').hide();
          $('.map-guide-step1--location').show();
          $('.map-guide-step1--reference').hide();
          resetProjectSearch();
        } else {
          toggleMode = 'proj';
          $('.search-geocoder').hide();
          $('.search-projectnr').show();
          $('.map-guide-step1--location').hide();
          $('.map-guide-step1--reference').show();
          resetGeocoder();
        }
      });

      map.on('load', () => {
        const polygon = {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [],
          },
        };
        map.addSource('polygon', polygon);

        map.addLayer({
          id: 'polygon',
          type: 'fill',
          source: 'polygon',
          layout: {},
          paint: {
            'fill-color': '#ffffff',
            'fill-opacity': 0.6,
          },
        });

        const singlepoint = {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [],
          },
        };

        map.addSource('single-point', singlepoint);

        map.addLayer({
          id: 'point',
          source: 'single-point',
          type: 'symbol',
          layout: {
            'icon-image': 'marker--center',
          },
        });

        if (!$('#map.bounds').length) {
          $.getJSON('https://reallyfreegeoip.org/json/', geodata => {
            map.flyTo({
              center: [geodata.longitude, geodata.latitude],
              zoom: 10,
              essential: true,
            });
          });
        } else {
          const localBounds = new mapboxgl.LngLatBounds();

          json.features.forEach(feature => {
            localBounds.extend(feature.geometry.coordinates);
          });

          map.fitBounds(localBounds, {maxZoom: 10});
        }
      }), {passive: true};

      const $hover = $(`
        <div
          id="hover"
          style="
            position: absolute;
            max-width: 240px;
            background-color: #fff;
            padding: 10px;
            border: 1px solid #f6f6f6;
            border-radius: 3px;
            box-shadow: 0 0 5px rgba(0,0,0,.1);
            z-index: 1;
          " />
      `);
      $hover.fadeOut(0);
      $('#map').before($hover);

      map.on('mousemove touchmove', ev => {
        const markerFeatures = map.queryRenderedFeatures(ev.point, {
          layers: ['markers'],
        });
        const markerName =
          markerFeatures.length && markerFeatures[0].properties.name;
        if (markerName) {
          $hover.html(markerName);
          $hover.fadeIn($hover.css('display') === 'none' ? 250 : 0);
          $hover.css({
            top: ev.originalEvent.offsetY - 15,
            left: ev.originalEvent.offsetX + 30,
          });
        } else {
          $hover.fadeOut(50);
        }
      }, {passive: true});

      map.on('click', ev => {
        const markerFeatures = map.queryRenderedFeatures(ev.point, {
          layers: ['markers'],
        });

        const isCluster =
          markerFeatures.length && markerFeatures[0].properties.cluster;
        const isMarker =
          markerFeatures.length && markerFeatures[0].properties.name;

        if (isCluster) {
          // zoom in
          map.flyTo({
            center: [ev.lngLat.lng, ev.lngLat.lat],
            zoom: Math.min(map.getMaxZoom(), map.getZoom() + 2),
          });
          return;
        }

        if (isMarker) {
          // open marker details
          const marker = markerFeatures[0];
          const btn = $('.form-teaser');
          btn.hide();
          const bypass = true;
          selectProject(marker, bypass);
          return;
        }

        const point = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [ev.lngLat.lng, ev.lngLat.lat],
          },
        };

        selectedPoint = point;

        let radius = parseInt($('.dash_projectmap--stayinformed-form #radius').val());
        let selectedLon = selectedPoint.geometry.coordinates[0];
        let selectedLat = selectedPoint.geometry.coordinates[1];

        updateProjectsList(json, radius, selectedLat, selectedLon);

        setRadius();
        locationClick = true;

        if ($(window).innerWidth() < 768) {
          const btn = $('.form-teaser');
          btn.find($('.location-teaser')).show();
          btn.find($('.project-teaser')).hide();
          btn.show();
          openForm();
          btn.hide();
        } else {
          openForm();
        }
      }), {passive: true};

      $('.dash_projectmap--stayinformed-form #radius').change(() => {
        setRadius();

        let radius = $('.dash_projectmap--stayinformed-form #radius').val();
        let selectedLon = selectedPoint.geometry.coordinates[0];
        let selectedLat = selectedPoint.geometry.coordinates[1];

        updateProjectsList(json, radius, selectedLat, selectedLon);
      });

      let attributesLoaded = false;
      map.on('data', data => {
        if (data.dataType === 'tile' && !attributesLoaded) {
          createMarkers();

          let prevQuery = '';

          $('.search-geocoder input[type="text"]').keyup(e => {
            const element = e.currentTarget;
            const searchString = $(element).val();
            if (searchString !== '') {
              if (e.which !== 40 && e.which !== 38 && e.which !== 13) {
                if (prevQuery !== searchString) {
                  prevQuery = searchString;
                  searchGeo(searchString);

                  $('.search-geocoder .suggestions li:first-of-type').addClass(
                    'active',
                  );
                }
              }

              if (!searchingGeocoder) {
                searchingGeocoder = true;
                $(document).on('keydown.searchGeocoder', keyEvent => {
                  if (keyEvent.which === 40) {
                    // DOWN.
                    const index = $('.search-geocoder .suggestions li').index(
                      $('.search-geocoder .suggestions li.active'),
                    );
                    $(
                      `.search-geocoder .suggestions li:nth-of-type(${index +
                      1})`,
                    ).removeClass('active');

                    if (
                      index ===
                      $('.search-geocoder .suggestions li').length - 1
                    ) {
                      $(
                        '.search-geocoder .suggestions li:first-of-type',
                      ).addClass('active');
                    } else {
                      $(
                        `.search-geocoder .suggestions li:nth-of-type(${index +
                        2})`,
                      ).addClass('active');
                    }
                  }
                  if (keyEvent.which === 38) {
                    // UP.
                    const index = $('.search-geocoder .suggestions li').index(
                      $('.search-geocoder .suggestions li.active'),
                    );
                    $(
                      `.search-geocoder .suggestions li:nth-of-type(${index +
                      1})`,
                    ).removeClass('active');

                    if (index === 0) {
                      $(
                        '.search-geocoder .suggestions li:last-of-type',
                      ).addClass('active');
                    } else {
                      $(
                        `.search-geocoder .suggestions li:nth-of-type(${index})`,
                      ).addClass('active');
                    }
                  }
                  if (keyEvent.which === 13) {
                    chooseLocation(
                      $('.search-geocoder .suggestions li.active').data(
                        'bounding',
                      ),
                      $('.search-geocoder .suggestions li.active').data('lon'),
                      $('.search-geocoder .suggestions li.active').data('lat'),
                    );
                  }
                });
              }

              $('.search-geocoder .geocoder-icon-close').show();
            } else {
              if (searchingGeocoder) {
                searchingGeocoder = false;
                $(document).off('.searchGeocoder');
              }
              $('.search-geocoder .suggestions').hide();
            }

            if ($(element).val() === '') {
              $('.search-geocoder .geocoder-icon-close').hide();
            }
          });

          $('.search-projectnr input[type="text"]').keyup(e => {
            const element = e.currentTarget;
            if ($(element).val() !== '') {
              if (e.which !== 40 && e.which !== 38 && e.which !== 13) {
                searchProject($(element).val());
                $('.search-projectnr .suggestions li:first-of-type').addClass(
                  'active',
                );
              }

              if (!searchingProject) {
                searchingProject = true;
                $(document).on('keydown.searchProject', keyEvent => {
                  if (keyEvent.which === 40) {
                    // DOWN.
                    const index = $('.search-projectnr .suggestions li').index(
                      $('.search-projectnr .suggestions li.active'),
                    );
                    $(
                      `.search-projectnr .suggestions li:nth-of-type(${index +
                      1})`,
                    ).removeClass('active');

                    if (
                      index ===
                      $('.search-projectnr .suggestions li').length - 1
                    ) {
                      $(
                        '.search-projectnr .suggestions li:first-of-type',
                      ).addClass('active');
                    } else {
                      $(
                        `.search-projectnr .suggestions li:nth-of-type(${index +
                        2})`,
                      ).addClass('active');
                    }
                  }
                  if (keyEvent.which === 38) {
                    // UP.
                    const index = $('.search-projectnr .suggestions li').index(
                      $('.search-projectnr .suggestions li.active'),
                    );
                    $(
                      `.search-projectnr .suggestions li:nth-of-type(${index +
                      1})`,
                    ).removeClass('active');

                    if (index === 0) {
                      $(
                        '.search-projectnr .suggestions li:last-of-type',
                      ).addClass('active');
                    } else {
                      $(
                        `.search-projectnr .suggestions li:nth-of-type(${index})`,
                      ).addClass('active');
                    }
                  }
                  if (keyEvent.which === 13) {
                    chooseProject(
                      $('.search-projectnr .suggestions li.active').data(
                        'project',
                      ),
                    );
                  }
                });
              }

              $('.search-projectnr .geocoder-icon-close').show();
            } else {
              if (searchingProject) {
                searchingProject = false;
                $(document).off('.searchProject');
              }
              $('.search-projectnr .suggestions').hide();
            }

            if ($(element).val() === '') {
              $('.search-projectnr .geocoder-icon-close').hide();
            }
          });

          attributesLoaded = true;
        }
      }, {passive: true});

      const allRadius = [];
      $('.dash_projectmap--stayinformed-form #radius option').each(
        (index, element) => {
          allRadius.push({value: $(element).val(), element: $(element)});
        },
      );

      map.on('zoomstart', () => {
        hideProjectBox();
      }), {passive: true};

      $('.paragraph-dash_projectmap .mapboxgl-canvas').click(() => {
        hideProjectBox();
      });

      $('.dash_projectmap--stayinformed-form .submit').click(e => {
        e.preventDefault();

        const validator = new Validator();
        const $form = $('.dash_projectmap--stayinformed-form');

        $form.find('.formitem').each((index, element) => {
          if ($(element).hasClass('required')) {
            if (
              $(element).hasClass('form-type-text') ||
              $(element).hasClass('form-type-password')
            ) {
              if (validator.validateString($(element).find('input'))) {
                $(element)
                  .find('input')
                  .removeClass('error')
                  .addClass('success');
                $(element)
                  .removeClass('has-error')
                  .addClass('has-success');

                $(element)
                  .find('.required-message')
                  .fadeOut();
              } else {
                $(element)
                  .find('input')
                  .removeClass('success')
                  .addClass('error');
                $(element)
                  .removeClass('has-success')
                  .addClass('has-error');

                $(element)
                  .find('.required-message')
                  .fadeIn();
              }
            }
            if ($(element).hasClass('form-type-email')) {
              if (validator.validateString($(element).find('input'))) {
                $(element)
                  .find('.required-message')
                  .fadeOut();

                if (validator.validateEmail($(element).find('input'))) {
                  $(element)
                    .find('input')
                    .removeClass('error')
                    .addClass('success');
                  $(element)
                    .removeClass('has-error')
                    .addClass('has-success');

                  $(element)
                    .find('.valid-message')
                    .fadeOut();
                } else {
                  $(element)
                    .find('input')
                    .removeClass('success')
                    .addClass('error');
                  $(element)
                    .removeClass('has-success')
                    .addClass('has-error');

                  $(element)
                    .find('.valid-message')
                    .fadeIn();
                }
              } else {
                $(element)
                  .find('input')
                  .removeClass('success')
                  .addClass('error');
                $(element)
                  .removeClass('has-success')
                  .addClass('has-error');

                $(element)
                  .find('.required-message')
                  .fadeIn();
              }
            }
          }
        });

        if ($('.has-error').length === 0) {
          const loading = Drupal.t(
            'Subscribing to projects...',
            {},
            {context: 'project_map'},
          );
          $('.dash_projectmap--stayinformed-info p').text(loading);
          $('.dash_projectmap--stayinformed-form').slideUp();
          const jsondata = {
            email: $form.find('input[name="email"]').val(),
            firstname: $form.find('input[name="firstname"]').val(),
            lastname: $form.find('input[name="lastname"]').val(),
            radius: $form.find('#radius').val(),
            cords: {
              lat: selectedPoint.geometry.coordinates[1],
              lon: selectedPoint.geometry.coordinates[0],
            },
          };

          $.post({
            url: '/sub/radius',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            dataType: 'json',
            data: JSON.stringify(jsondata),
          }).done(data => {
            const message = data.message.replace(/(?:\r\n|\r|\n)/g, '<br />');
            $('.dash_projectmap--stayinformed-info p').html(message);
            $('.dash_projectmap--stayinformed-form').slideUp();
            subscribed = true;
          });
        } else {
          // console.log("there are still errors");.
        }
      });

      $('.dash_projectmap--infoblock .close').click(() => {
        formClosed = true;
        hideProjectBox();
      });

      $('.dash_projectmap--stayinformed .close').click(() => {
        formClosed = true;
        $('.dash_projectmap--stayinformed').fadeOut(250);
      });

      $('.search-geocoder .geocoder-icon-close').click(e => {
        $(e.currentTarget).hide();
        resetGeocoder();
      });

      $('.search-projectnr .geocoder-icon-close').click(e => {
        $(e.currentTarget).hide();
        resetProjectSearch();
      });

      const buttonsToStayInformed = $("a[href$='#project-map']");

      for (let i = 0; i < buttonsToStayInformed.length; i++) {
        buttonsToStayInformed[i].addEventListener('click', () => {
          openForm();
        });
      }

      $('.dash_projectmap--stayinformed')[0].addEventListener('click', () => {
        if (!selectedPoint && !formClosed) {
          setWarningStep1();
        }
      });
    },
  };

  Drupal.behaviors.splitMap = {
    attach(context, settings) {

      var $map = $('.dash_projectmap--map', context);
      var $list = $('.dash_projectmap--list', context);
      $('.map-toggle-container').on('click', () => {
        $('.dash_projectmap--infoblock').css('display', 'none');
        $map.toggleClass('split');
        $list.toggleClass('split');
        //$('.toggle--icon', context).toggleClass('icon-list icon-map');
        $('.toggle--map', context).toggleClass('visible');
        $('.toggle--list', context).toggleClass('visible');
      });

    },
  };

  function updateProjectsList(json, radius, selectedLat, selectedLon) {
    $('.map-n-list .overview--list_items').remove();
    let $projectsTable = `<div class="overview--list_items"></div>`;
    $('.map-n-list .overview--list').append($projectsTable);

    let empty = true;
    json.features.forEach(project => {
      let lon = project.geometry.coordinates[0];
      let lat = project.geometry.coordinates[1]
      let dis = getDistanceFromLatLonInM(selectedLat, selectedLon, lat, lon);

      if (dis <= radius) {
        empty = false;
        $projectsTable +=
          `<a href="${project.url}" class="project overview--list_item">
               <div data-filter="start_date" class="overview--list_header-date overview--list_item-column"><span class="filterlabel">${Drupal.t('Start date')}</span>${project.dates.project_start}</div>
               <div data-filter="end_date" class="overview--list_header-date overview--list_item-column"><span class="filterlabel">${Drupal.t('End date')}</span>${project.dates.project_end}</div>
               <div data-filter="project_name" class="overview--list_header-name overview--list_item-column">${project.properties.name}</div>
               </a>`;
      }
    });

    let emptyText = Drupal.t('Wijzig de locatie en radius om een lijst van projecten in een regio te zien.');
    if (empty) {
      $projectsTable = `<div class="overview--list_items">${emptyText}</div>`;
    }
    $('.map-n-list .overview--list_items').append($projectsTable);
  }

  function getDistanceFromLatLonInM(lat1, lon1, lat2, lon2) {
    let R = 6371;
    let dLat = deg2rad(lat2 - lat1);
    let dLon = deg2rad(lon2 - lon1);
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c) * 1000; // Meters.
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180)
  }

})(jQuery, Drupal, mapboxgl, Fuse, Validator);
